export interface CaretPos {
  left?: string;
  right?: string;
}

// use "const enum" for backward compatibility with raw menu state strings
// "const enum" forces Typescript to simply inline the enum value when compiled
export const enum MenuState {
  Open = `open`,
  Closed = `closed`,
}
